var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "option-select", attrs: { id: "monitor_option" } },
    [
      _c("v-select", {
        attrs: { items: _vm.options, "hide-details": "" },
        model: {
          value: _vm.current_option_value,
          callback: function($$v) {
            _vm.current_option_value = $$v
          },
          expression: "current_option_value"
        }
      }),
      _vm._v("\n    " + _vm._s(_vm.description) + "\n")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }